import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import * as infoYellowSrc from '../../../../../assets/zemplin/info-yellow.svg';
import * as infoRedSrc from '../../../../../assets/zemplin/info-red.svg';
import * as arrowSrc from '../../../../../assets/zemplin/arrow-triangle-gray.svg';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexColCenter,
  FlexRowCenter,
} from '../../../Defaults/Flexbox/Flexbox';
import { Icon } from '../../../Defaults/Defaults';
import { IconImg } from '../../../Defaults/Icon/IconImg';

interface Props {
  message: string;
  isAvailable: boolean;
  moveLeft?: boolean;
  leftPosition?: string;
  isRed: boolean;
}

function CartInfoPopup({
  isAvailable,
  moveLeft,
  leftPosition,
  message,
  isRed,
}: Props) {
  const [popupVisiblity, setPopupVisiblity] = React.useState(false);
  const handleMouseOver = () => {
    setPopupVisiblity(true);
  };
  const handleMouseLeave = () => {
    setPopupVisiblity(false);
  };

  return (
    <Wrapper>
      <IconImg
        onClick={handleMouseOver}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        width={20}
        height={20}
        alt="info-icon"
        src={isRed ? infoRedSrc.toString() : infoYellowSrc.toString()}
      />

      <AbsoluteWrapper>
        <PopUpContainer
          leftPosition={leftPosition}
          moveLeft={moveLeft}
          show={popupVisiblity}
        >
          <PopUpValidationMessage>
            <Stores>{message}</Stores>
          </PopUpValidationMessage>
          <ArrowIcon moveLeft={moveLeft}>
            <Icon src={arrowSrc.toString()} />
          </ArrowIcon>
        </PopUpContainer>
      </AbsoluteWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
`;

const Stores = styled(FlexCol)`
  padding: ${rem(16)} 0;
`;

const AbsoluteWrapper = styled.div`
  position: absolute;
  min-width: ${rem(100)};
`;

const StoreInfoText = styled(FlexRowCenterVertical)`
  color: white;
  margin-bottom: ${rem(16)};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  line-height: ${rem(16)};
  justify-content: space-between;

  &:last-child {
    margin: 0;
  }
`;

const PopUpContainer: any = styled(FlexColCenter)<{
  moveLeft?: boolean;
  leftPosition?: string;
}>`
  width: ${rem(200)};
  position: absolute;
  color: #fff;
  opacity: ${(props: any) => (props.show ? 1 : 0)};
  visibility: ${(props: any) => (props.show ? 'visible' : 'hidden')};
  transition: opacity 0.6s;
  transform: ${({ moveLeft }) => (moveLeft ? 'translateY(-50%)' : 'none')};
  top: ${({ moveLeft }) => (moveLeft ? '10px' : 'unset')};
  right: -10px;

  bottom: ${({ moveLeft }) => (moveLeft ? 'unset' : '-5px')};
  z-index: 50;
  flex-flow: ${({ moveLeft }) => (moveLeft ? 'row' : 'column')};
`;

const PopUpValidationMessage = styled(FlexRowCenter)`
  width: 100%;
  min-height: ${rem(35)};
  padding: ${rem(6)} ${rem(11)};
  background: rgb(0, 0, 0, 0.72);
  border-radius: ${rem(4)};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
`;

const ArrowIcon = styled(FlexRowCenter)<{ moveLeft?: boolean }>`
  width: ${rem(15)};
  height: ${rem(15)};
  position: relative;
  transform: ${({ moveLeft }) => (moveLeft ? 'rotate(270deg)' : 'none')};
  right: ${({ moveLeft }) => (moveLeft ? rem(3.2) : 'unset')};
  top: ${({ moveLeft }) => (moveLeft ? 'unset' : '-4px')};
`;

const Quantity = styled.span`
  margin-left: ${rem(16)};
  white-space: nowrap;
`;

export { CartInfoPopup };
